export const SCROLL_SPY_OFFSET = 96

export const SECTION_IDS = ['home', 'about', 'resume', 'contact']

export function getActiveSection(scrollY = window.scrollY, offset = SCROLL_SPY_OFFSET) {
  let current = SECTION_IDS[0]

  for (const id of SECTION_IDS) {
    const el = document.getElementById(id)
    if (!el) continue

    const top = el.getBoundingClientRect().top + scrollY
    if (scrollY + offset >= top) {
      current = id
    }
  }

  return current
}
